/**
 * @deprecated Keywords have been moved into `@wre/infinity-generators`. This object contains the keywords that were
 * being used in other places, such as table headers or labels on arrows. These should be moved to a more sensible
 * place.
 */
export default {
  '2-D shapes': '2-D shapes',
  '3-D shapes': '3-D shapes',
  Acute: 'Acute',
  Adults: 'Adults',
  Area: 'Area',
  Capacities: 'Capacities',
  Capacity: 'Capacity',
  Celsius: '°C',
  Children: 'Children',
  Counters: 'Counters',
  Cubes: 'Cubes',
  Day: 'Day',
  Decimal: 'Decimal',
  Decrease: 'Decrease',
  Distance: 'Distance',
  Earliest: 'Earliest',
  Equilateral: 'Equilateral',
  'Equivalent fractions': 'Equivalent fractions',
  False: 'False',
  Fewest: 'Fewest',
  First: 'First',
  Fraction: 'Fraction',
  Greatest: 'Greatest',
  Group: 'Group',
  Half: 'Half',
  Heavier: 'Heavier',
  Height: 'Height',
  Hundreds: 'Hundreds',
  Hundredths: 'Hundredths',
  Increase: 'Increase',
  Integer: 'Integer',
  Integers: 'Integers',
  Imperial: 'Imperial',
  Improper: 'Improper',
  Isosceles: 'Isosceles',
  Irregular: 'Irregular',
  kg: 'kg',
  Latest: 'Latest',
  Last: 'Last',
  Least: 'Least',
  Length: 'Length',
  Lengths: 'Lengths',
  Lighter: 'Lighter',
  Longest: 'Longest',
  m: 'm',
  Marbles: 'Marbles',
  Mass: 'Mass',
  Masses: 'Masses',
  Metric: 'Metric',
  'Minutes past': 'Minutes past',
  'Minutes to': 'Minutes to',
  Mixed: 'Mixed',
  'Mixed number': 'Mixed number',
  Most: 'Most',
  Obtuse: 'Obtuse',
  'One quarter': 'One quarter',
  Ones: 'Ones',
  Pattern: 'Pattern',
  Percentage: 'Percentage',
  Percentages: 'Percentages',
  Perimeter: 'Perimeter',
  Point: 'Point',
  Polygons: 'Polygons',
  Quadrilateral: 'Quadrilateral',
  Ratios: 'Ratios',
  Rectangle: 'Rectangle',
  Regular: 'Regular',
  Remainder: 'Remainder',
  Scalene: 'Scalene',
  Shorter: 'Shorter',
  Shortest: 'Shortest',
  Smallest: 'Smallest',
  Square: 'Square',
  Statements: 'Statements',
  Taller: 'Taller',
  Temperature: 'Temperature',
  Tens: 'Tens',
  Tenths: 'Tenths',
  Thousands: 'Thousands',
  Thousandths: 'Thousandths',
  Time: 'Time',
  Total: 'Total',
  Triangle: 'Triangle',
  True: 'True',
  Volume: 'Volume',
  Whole: 'Whole',
  Wholes: 'Wholes'
};
